import React, { useState } from 'react';
import '../styles/Checklist.css';

const Checklist = () => {
  const [expandedTable, setExpandedTable] = useState(null);

  const toggleTable = (tableName) => {
    setExpandedTable(expandedTable === tableName ? null : tableName);
  };

  return (
    <div className="checklist-page">
      <section className="checklist-hero">
        <div className="checklist-hero-content">
          <h1>Don't Miss a Spot</h1>
          <p>Use our comprehensive cleaning checklist to ensure every corner of your space receives the attention it deserves. From baseboards to ceiling fans, we take pride in delivering spotless results every time.</p>
          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">50+</span>
              <span className="stat-label">Checkpoints</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Satisfaction</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">5★</span>
              <span className="stat-label">Rating</span>
            </div>
          </div>
        </div>
      </section>

      <section className="checklist-content">
        <div className={`checklist-table ${expandedTable === 'living' ? 'expanded' : ''}`}>
          <div className="checklist-header" onClick={() => toggleTable('living')}>
            <div className="area-header">
              <div className="area-icon">🧹</div>
              <h2>Living Rooms / Bedrooms / Hallways</h2>
            </div>
            <div className="service-types">
              <span>Standard</span>
              <span>Deep</span>
              <span>Move In / Out</span>
            </div>
            <div className="expand-icon">▶</div>
          </div>
          
          <div className="checklist-items">
            {[
              { task: "Removing Cobwebs From Ceilings", note: "(Within Reach*)", checks: [true, true, true] },
              { task: "Dust Ceiling Fans & Light Fixtures", note: "(Within Reach*)", checks: [true, true, true] },
              { task: "Dusting & Wiping Of Windowsills & Blinds", checks: [true, true, true] },
              { task: "Cleaning Of Windowpanes", note: "(Inside Only*)", checks: [false, true, true] },
              { task: "Dusting & Cleaning Off Of Shelves, Ledges, Desk, & Other Surfaces", checks: [true, true, true] },
              { task: "Feather Dust Wall Arts & Dust Around Nik Naks", note: "(Within Reach*)", checks: [true, true, false] },
              { task: "Dusting Of TV, Monitors, & Other Electronics", checks: [true, true, false] },
              { task: "Dusting & Wiping Of Light Switches", checks: [true, true, true] },
              { task: "Dusting Of Door Frames", note: "(Within Reach*)", checks: [true, true, true] },
              { task: "Clean / Wipe Mirrors & Glass Items", checks: [true, true, true] },
              { task: "Hand Detailing & Cleaning Of Exposed Baseboards", checks: [false, true, true] },
              { task: "Checking / Bagging Garbage Or Trash Under Beds", note: "(Within Reach*)", checks: [true, true, false] },
              { task: "Change Linens / Make Beds", note: "(If Linens Are Available*)", checks: [true, true, false] },
              { task: "Remove Trash & Replace Trash Can Liners", note: "(Liners Must Be Provided*)", checks: [true, true, false] },
              { task: "Sweep & Mop All FLOORING", note: "(Hard Wood / Tile Flooring / etc.)", checks: [true, true, true] },
              { task: "Vacuuming Of Carpet Flooring & Around Furniture", note: "(Furniture CANNOT Be Moved*)", checks: [true, true, true] },
              { task: "Vacuuming Out Of Closets", checks: [false, false, true] },
              { task: "Vacuum / Clean Inside Furniture", checks: [true, true, false] },
              { task: "Set / Stage Living Room Items", checks: [true, true, false] }
            ].map((item, index) => (
              <div key={index} className="checklist-item">
                <span className="task-name">
                  {item.task}
                  {item.note && <em>{item.note}</em>}
                </span>
                <div className="service-checks">
                  {item.checks.map((isChecked, i) => (
                    <span key={i} className={`check ${isChecked ? 'included' : ''}`}>
                      {isChecked ? '✓' : '○'}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={`checklist-table ${expandedTable === 'kitchen' ? 'expanded' : ''}`}>
          <div className="checklist-header" onClick={() => toggleTable('kitchen')}>
            <div className="area-header">
              <div className="area-icon">🍳</div>
              <h2>Kitchen</h2>
            </div>
            <div className="service-types">
              <span>Standard</span>
              <span>Deep</span>
              <span>Move In / Out</span>
            </div>
            <div className="expand-icon">▶</div>
          </div>
          
          <div className="checklist-items">
            {[
              { task: "Removing Cobwebs From Ceilings", note: "(Within Reach*)", checks: [true, true, true] },
              { task: "Dust Reachable Vents", checks: [true, true, true] },
              { task: "Dust Ceiling Fans & Light Fixtures", note: "(Within Reach*)", checks: [true, true, true] },
              { task: "Dusting & Wiping Of Windowsills & Blinds", checks: [false, true, true] },
              { task: "Cleaning Of Windowpanes", note: "(Inside Only*)", checks: [false, true, true] },
              { task: "Dusting & Cleaning Off Of Shelves, Ledges, & Other Surfaces", checks: [true, true, true] },
              { task: "Feather Dust Wall Art & Dust Around Nik Naks", note: "(Within Reach*)", checks: [true, true, false] },
              { task: "Dusting & Wiping Of Light Switches", checks: [true, true, true] },
              { task: "Dusting Of Door Frames", note: "(Within Reach*)", checks: [true, true, true] },
              { task: "Cleaning The Inside Of Microwaves", checks: [true, true, true] },
              { task: "Clean Inside Of Fridge, Freezer, & Stove", checks: [false, false, true] },
              { task: "Cleaning Of Stove Tops", checks: [true, true, true] },
              { task: "Clean Hood Vents", checks: [false, true, true] },
              { task: "Clean Exterior Surfaces Of Fridge, Stove, Microwave, Dishwasher", checks: [true, true, true] },
              { task: "Clean Inside Of Cabinets & Drawers", checks: [false, false, true] },
              { task: "Clean Exteriors Of Cabinet Fronts & Drawers Fronts", checks: [true, true, true] },
              { task: "Removing Of Items From Counter Tops & Cleaning All Counter Tops", checks: [true, true, false] },
              { task: "Clean & Sanitizing Of Counter Tops & Ledges", checks: [true, true, true] },
              { task: "Wipe, Clean & Dry Of Sinks / Faucets", checks: [true, true, true] },
              { task: "Wipe Mirrors And Glass Items", checks: [true, true, true] },
              { task: "Take Out Trash & Replace Liner", note: "(Liner Must Be Provided*)", checks: [true, true, true] },
              { task: "Sweep & Mop Floors", checks: [true, true, true] }
            ].map((item, index) => (
              <div key={index} className="checklist-item">
                <span className="task-name">
                  {item.task}
                  {item.note && <em>{item.note}</em>}
                </span>
                <div className="service-checks">
                  {item.checks.map((isChecked, i) => (
                    <span key={i} className={`check ${isChecked ? 'included' : ''}`}>
                      {isChecked ? '✓' : '○'}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={`checklist-table ${expandedTable === 'bathroom' ? 'expanded' : ''}`}>
          <div className="checklist-header" onClick={() => toggleTable('bathroom')}>
            <div className="area-header">
              <div className="area-icon">🚿</div>
              <h2>Bathrooms</h2>
            </div>
            <div className="service-types">
              <span>Standard</span>
              <span>Deep</span>
              <span>Move In / Out</span>
            </div>
            <div className="expand-icon">▶</div>
          </div>
          
          <div className="checklist-items">
            {[
              { task: "Removing Cobwebs From Ceilings", note: "(Within Reach*)", checks: [true, true, true] },
              { task: "Dust Reachable Vents", checks: [true, true, true] },
              { task: "Dust Light Fixtures", note: "(Within Reach*)", checks: [true, true, true] },
              { task: "Dusting & Wiping Of Windowsills & Blinds", checks: [false, true, true] },
              { task: "Cleaning Of Windowpanes", note: "(Inside Only*)", checks: [false, true, true] },
              { task: "Clean & Sanitize Countertops & Vanity", checks: [true, true, true] },
              { task: "Clean & Sanitize Sinks & Faucets", checks: [true, true, true] },
              { task: "Clean & Sanitize Toilets", note: "(Inside & Outside)", checks: [true, true, true] },
              { task: "Clean & Sanitize Shower / Tub", checks: [true, true, true] },
              { task: "Clean Shower Door / Curtain", checks: [true, true, true] },
              { task: "Clean & Sanitize Shower Head & Faucets", checks: [true, true, true] },
              { task: "Clean Tile Walls", checks: [true, true, true] },
              { task: "Deep Clean Grout", note: "(Upon Request*)", checks: [false, true, true] },
              { task: "Clean Inside Medicine Cabinet", note: "(If Empty)", checks: [false, false, true] },
              { task: "Clean Inside Vanity & Drawers", note: "(If Empty)", checks: [false, false, true] },
              { task: "Clean Exterior Of Cabinets & Drawers", checks: [true, true, true] },
              { task: "Clean & Shine Mirrors", checks: [true, true, true] },
              { task: "Dusting & Wiping Of Light Switches & Door Knobs", checks: [true, true, true] },
              { task: "Clean & Sanitize Door Frames", checks: [true, true, true] },
              { task: "Clean & Organize Toiletries On Counter", checks: [true, true, false] },
              { task: "Clean & Sanitize Toilet Paper Holder", checks: [true, true, true] },
              { task: "Clean & Sanitize Towel Racks", checks: [true, true, true] },
              { task: "Take Out Trash & Replace Liner", note: "(Liner Must Be Provided*)", checks: [true, true, true] },
              { task: "Sweep & Mop Floors", checks: [true, true, true] }
            ].map((item, index) => (
              <div key={index} className="checklist-item">
                <span className="task-name">
                  {item.task}
                  {item.note && <em>{item.note}</em>}
                </span>
                <div className="service-checks">
                  {item.checks.map((isChecked, i) => (
                    <span key={i} className={`check ${isChecked ? 'included' : ''}`}>
                      {isChecked ? '✓' : '○'}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={`checklist-table ${expandedTable === 'extra' ? 'expanded' : ''}`}>
          <div className="checklist-header" onClick={() => toggleTable('extra')}>
            <div className="area-header">
              <div className="area-icon">🏠</div>
              <h2>Extra Rooms</h2>
            </div>
            <div className="service-types">
              <span>Standard</span>
              <span>Deep</span>
              <span>Move In / Out</span>
            </div>
            <div className="expand-icon">▶</div>
          </div>
          
          <div className="checklist-items">
            {[
              { task: "Removing Of Cobwebs Throughout", checks: [false, false, true] },
              { task: "Dust & Wipe Down Outside Of Washer & Dryer", checks: [true, true, true] },
              { task: "Cleaning Of Glass Doorways & Windows", note: "(Inside Home Only*)", checks: [false, false, true] },
              { task: "Picking Up & Bagging Of Trash", checks: [true, true, true] },
              { task: "Sweeping Of Complete Flooring", checks: [false, false, true] },
              { task: "Mopping Of Tile Flooring", checks: [false, false, true] },
              { task: "Vacuuming Of Carpet Flooring", checks: [false, false, true] }
            ].map((item, index) => (
              <div key={index} className="checklist-item">
                <span className="task-name">
                  {item.task}
                  {item.note && <em>{item.note}</em>}
                </span>
                <div className="service-checks">
                  {item.checks.map((isChecked, i) => (
                    <span key={i} className={`check ${isChecked ? 'included' : ''}`}>
                      {isChecked ? '✓' : '○'}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Checklist; 